import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { StockLocation } from '@idealsupply/products-api-angular-client';
import { LeadTimeNotificationChipComponentLocalize } from './lead-time-notification-chip.component.localize';

@Component({
  selector: 'ideal-lead-time-notification-chip',
  imports: [MatIconModule],
  templateUrl: './lead-time-notification-chip.component.html',
  styleUrl: './lead-time-notification-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.in-stock]': 'hasStock()',
  },
})
export class LeadTimeNotificationChipComponent {
  public readonly short = input<boolean>();
  public readonly stockLocation = input<StockLocation>();
  public readonly hasStock = computed(() => {
    switch (this.stockLocation()) {
      case StockLocation.InStock:
      case StockLocation.InWarehouse:
        return true;
      default:
        return false;
    }
  });

  protected readonly label = computed(
    () => LeadTimeNotificationChipComponentLocalize[this.short() ? 'short' : 'long'][this.hasStock() ? 'in-stock' : 'unconfirmed'],
  );

  protected readonly icon = computed(() => (this.hasStock() ? 'check_circle' : 'schedule'));
}
